import React from "react";
import { Box, Typography, Button, Grow, Fade } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import CLogo from "../../Components/Reusable/Logo";

export const FacebookSuccess = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 4,
        px: 2,
        py: 4,
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <Fade in timeout={500}>
        <Box>
          <CLogo showText={true} size="52px" textSize="26px" />
        </Box>
      </Fade>

      <Grow in timeout={450}>
        <Box
          sx={{
            width: "100%",
            maxWidth: 440,
            borderRadius: 4,
            overflow: "hidden",
            bgcolor: "#fff",
            boxShadow: "0 32px 64px rgba(0,0,0,0.25)",
          }}
        >
          <Box
            sx={{
              position: "relative",
              background: "linear-gradient(135deg,#10b981,#059669)",
              py: 5,
              textAlign: "center",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: -30,
                right: -30,
                width: 140,
                height: 140,
                borderRadius: "50%",
                bgcolor: "rgba(255,255,255,0.08)",
              }}
            />
            <Box
              sx={{
                position: "relative",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 88,
                height: 88,
                borderRadius: "50%",
                bgcolor: "rgba(255,255,255,0.15)",
                mb: 1.5,
              }}
            >
              <CheckCircleOutlineIcon sx={{ fontSize: 60, color: "#fff" }} />
              <Box
                sx={{
                  position: "absolute",
                  bottom: -4,
                  right: -4,
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  bgcolor: "#1877F2",
                  border: "2.5px solid #fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FacebookRoundedIcon sx={{ fontSize: 18, color: "#fff" }} />
              </Box>
            </Box>
            <Typography variant="h5" fontWeight={700} color="#fff">
              Facebook Connected!
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.85)", mt: 0.5 }}>
              Your page has been linked successfully
            </Typography>
          </Box>

          <Box sx={{ px: 3.5, py: 3.5, textAlign: "center" }}>
            <Typography variant="body2" sx={{ color: "#64748b", mb: 3, lineHeight: 1.6 }}>
              You can now schedule and publish posts to your Facebook Page
              directly from OruClick, right alongside your other connected
              accounts.
            </Typography>

            <Button
              fullWidth
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate("/dashboard")}
              sx={{
                py: 1.4,
                borderRadius: 2,
                fontWeight: 700,
                textTransform: "none",
                fontSize: "1rem",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 4px 14px rgba(102, 126, 234, 0.45)",
                "&:hover": {
                  background: "linear-gradient(135deg, #5a6fd6 0%, #6a3d9a 100%)",
                  boxShadow: "0 6px 20px rgba(102, 126, 234, 0.55)",
                },
              }}
            >
              Go to Dashboard
            </Button>
          </Box>
        </Box>
      </Grow>
    </Box>
  );
};

export default FacebookSuccess;
